"use client"

import Link from "next/link"
import { ArrowRight, FileText } from "lucide-react"
import { useTranslations } from "next-intl"

export function TechLabCTA() {
  const t = useTranslations("techLab.cta")
  
  return (
    <section className="py-24">
      <div className="relative rounded-3xl border border-slate-400/20 bg-gradient-to-br from-slate-400/5 via-background to-slate-500/5 p-8 md:p-12 lg:p-16 overflow-hidden">
        {/* Background decoration */}
        <div className="absolute top-0 right-0 w-96 h-96 bg-slate-400/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" />
        
        <div className="relative z-10 max-w-2xl">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            {t("title")}
          </h2>
          
          <p className="text-muted-foreground text-lg mb-8 leading-relaxed">
            {t("subtitle")}
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              href="/manifiesto/madeira"
              className="group inline-flex items-center justify-center gap-2 rounded-lg bg-slate-600 px-6 py-3 text-sm font-medium text-white transition-all hover:bg-slate-700 hover:gap-3"
            >
              <FileText className="h-4 w-4" />
              {t("readManifiesto")}
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
            </Link>
            
            <Link
              href="/contact?topic=technology"
              className="inline-flex items-center justify-center gap-2 rounded-lg border border-border bg-card/50 px-6 py-3 text-sm font-medium text-foreground transition-all hover:bg-card hover:border-slate-400/50"
            >
              {t("discussRequirements")}
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}
